import styled from 'styled-components';

export const AutoSuggest = styled.section`
  background: white;
  box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
  border-radius: 1.2rem;
  display: flex;
  flex-direction: column;
  width: 53rem;
  z-index: 7;
  max-height: 48rem;
  overflow-y: auto;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

export const Categories = styled.div(
    props => `
    h4{
        font-family: ${props.theme.font.fontFamily};
        color: #898b91;
        font-size: 1.8rem;
        font-weight: 600;
        padding: 3rem 2rem 1.5rem;
        border-bottom: 1px solid #eff3f8;
    }    
`
);

export const ListItem = styled.li`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem 2rem;
    border-bottom: 1px solid #eff3f8;
    cursor: pointer;
    &:hover {
        background-color: #eef4fd;
    }
`;
export const ListItemContent = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: 1rem;
    flex: 1;
`
export const MainTxt = styled.p`
    flex: 1;
    font-size: 1.6rem;
    color: black;
    text-transform:capitalize;
`
export const SubTxt = styled.p`
    font-size: 1.2rem;
    color: #4f525a;
    padding-top: 0.5rem;
`
export const CurrentLocation = styled.div(
    props => `
    background-color: ${props?.selected ? '#eef4fd' : 'initial'};
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1.5rem;
    border-bottom: 1px solid #eff3f8;
    cursor: pointer;
    `
)

export const LocTxt = styled.span`    
    color: #2276e3;
    font-size: 1.6rem;
    padding-left: 1rem
`

export const KeyBoardSelectedCard = styled.div(
    props => `
    cursor: 'pointer';
    background-color: ${props?.selected ? '#eef4fd' : 'initial'};
    `
)

